import React, { useMemo } from "react";
import { useStarterConversations } from "@dev-streetbeat/chat";
import styles from "./suggestedPrompts.module.css";
import * as SuggestedIconsIndex from "shared/assets/svg/suggested-prompts/SuggestedPromptsIndex";


type SuggestedPromptsProps = {
  onSend?: (text: string) => void;
};


export const SuggestedPrompts: React.FC<SuggestedPromptsProps> = ({
  onSend,
}) => {
  const { starterConversations, loading, error } = useStarterConversations();
  let forceStyleGuide = false;

  const suggestedPromptsList = starterConversations || [];

  const gridClass = useMemo(() => {
    const itemCount = suggestedPromptsList.length;

    if (forceStyleGuide) return styles.gridTriple;
    if (itemCount <= 1) return styles.gridSingle;
    if (itemCount <= 4) return styles.gridDouble;
    if (itemCount <= 6) return styles.gridTriple;
  }, [suggestedPromptsList.length]);

  const getIconComponent = (iconName: string) => {
    const { SuggestedPromptIcon4 } = SuggestedIconsIndex;

    if (!iconName || typeof iconName !== 'string') {
      return <SuggestedPromptIcon4 className={styles.iconPrompt} />;
    }

    const IconComponent =
      SuggestedIconsIndex[iconName as keyof typeof SuggestedIconsIndex];
    
    if (IconComponent) {
      return <IconComponent className={styles.iconPrompt} />;
    }

    return <SuggestedPromptIcon4 className={styles.iconPrompt} />;
  };

  if (loading || !suggestedPromptsList.length) {
    return null;
  }

  if (error) {
    return null;
  }


  return (
    <div className={styles.wrapper}>
      <div className={`${styles.gridContainer} ${gridClass}`}>
        {suggestedPromptsList.map((message, idx) => (
          <div
            key={`init_${idx}`}
            className={styles.gridItemContainer}
            onClick={() => onSend?.(message.content)}
          >
            <div className={styles.gridItem}>
              {getIconComponent(message.icon)}
              {message.content}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuggestedPrompts;
